module.exports = __webpack_public_path__ + "static/826fd6e55d77e4aac8b0b51aff22a1f4.webp";